export enum GroupType {
    CUSTOM = 'custom',
    AUTOMATIC = 'automatic'
}
